import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import CommonSubHeader from '../../SubHeader';
import FullTextSearch from './FullTextSearch';
import AirButton from '../../../../common/components/AirButton';
import { DownloadIcon } from '../../../../common/icons';

import './SubHeader.css';

@inject('translationsStore')
@observer
class SubHeader extends Component {
  render() {
    const { translationsStore } = this.props;
    const cls = classNames({
      DMDSubHeader: true
    });
    return (
      <CommonSubHeader className={cls}>
        <FullTextSearch placeholder={this.props.translationsStore.translate('search.placeholderSearch')} />
        <div className="SubHeaderLast">
          <AirButton
            className="export"
            icon={<DownloadIcon style={{ width: '13px', height: '16px' }} />}
            label={translationsStore.translate('export')}
            onClick={this.props.onExportClick}
          />
        </div>
      </CommonSubHeader>
    );
  }
}

export default SubHeader;



// WEBPACK FOOTER //
// ./src/components/App/DriversManagerDashboard/SubHeader/SubHeader.js